/* eslint-disable multiline-ternary */
import { Avatar, Box, Flex, Spinner, Text, Heading } from '@chakra-ui/react'
import { FormattedMessage } from 'react-intl'
import { makeAlphaDate } from '../../../../../utils/dateUtils'
import messages from './messages'
import { type Patient } from '../../../../../model/patient'
import { Link } from 'react-router-dom'
import { useAppDispatch } from '../../../../../store/hooks'
import { setCurrentPatient } from '../../../../../reducers/currentPatientReducer'
import { setVisits } from '../../../../../reducers/currentVisitsReducer'

interface Props {
  latestPatients: Patient[]
  latestPatientsLoading: boolean
}

export default function LatestPatients({
  latestPatients,
  latestPatientsLoading
}: Props) {
  const dispatch = useAppDispatch()

  const handlePatientClick = (patient: Patient) => {
    dispatch(setVisits([]))
    dispatch(setCurrentPatient(patient))
  }

  return (
    <Flex
      flex={1}
      flexDir="column"
      gap={4}
      bg="white"
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="xl"
      p={5}
      minW={0}
    >
      <Heading size="sm">
        <FormattedMessage {...messages.latestPatients} />
      </Heading>
      <Box flex={1} minH="120px">
        {latestPatientsLoading ? (
          <Flex justifyContent="center">
            <Spinner />
          </Flex>
        ) : latestPatients.length === 0 ? (
          <Flex justifyContent="center" alignItems="center" height="100%">
            <Text color="gray.500">
              <FormattedMessage {...messages.noPatients} />
            </Text>
          </Flex>
        ) : (
          <Flex flexDir="column" gap={1}>
            {latestPatients.map((patient) => (
              <Link to={`/patients/${patient.id}`} key={patient.id}>
                <Flex
                  p={2}
                  gap={3}
                  flexWrap="wrap"
                  borderRadius={10}
                  _hover={{ bg: 'gray.50' }}
                  justifyContent="space-between"
                  onClick={() => {
                    handlePatientClick(patient)
                  }}
                >
                  <Flex gap={4}>
                    <Avatar size="sm" name={patient.name} />
                    <Flex flexDir="column" justifyContent="center">
                      <Text fontSize="sm" fontWeight="500">
                        {patient.name}
                      </Text>
                    </Flex>
                  </Flex>
                  <Flex flexDirection="column" justifyContent="center">
                    <Text color="gray" fontSize="xs">
                      joined on {makeAlphaDate(patient.createdAt)}
                    </Text>
                  </Flex>
                </Flex>
              </Link>
            ))}
          </Flex>
        )}
      </Box>
    </Flex>
  )
}
